export const FIAT_MULTIPLIER = 1000;
export const CRYPTO_MULTIPLIER = 100000000;
export const DEFAULT_FRACTION_DIGITS = 2;
export const DEFAULT_CURRENCY = 'EUR';
